import { render, staticRenderFns } from "./AppointmentSlot.vue?vue&type=template&id=ded15fbe&scoped=true"
import script from "./AppointmentSlot.vue?vue&type=script&lang=js"
export * from "./AppointmentSlot.vue?vue&type=script&lang=js"
import style0 from "./AppointmentSlot.vue?vue&type=style&index=0&id=ded15fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded15fbe",
  null
  
)

export default component.exports